export class AwsEbsSnapshotConvertResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEbsSnapshotConvertResult.attributeTypeMap;
    }
    constructor() {
    }
}
